import React, { JSX, useEffect, useState } from 'react';
import { Canvas, useThree, useFrame, useLoader } from '@react-three/fiber';
import CaseModel from './CaseModel';
import { OrbitControls } from '@react-three/drei';
import * as THREE from 'three';
import { useRef } from 'react';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

function CaseCapture({ onCapture }: { onCapture: (img: string) => void }) {
  const { gl, scene, camera } = useThree();
  const [captured, setCaptured] = useState(false);

  useEffect(() => {
    if (!captured) {
      const timer = setTimeout(() => {
        gl.render(scene, camera); // гарантируем рендер
        const imgData = gl.domElement.toDataURL("image/png");
        onCapture(imgData);
        setCaptured(true);
      }, 300); // задержка 300 мс (можно увеличить)

      return () => clearTimeout(timer);
    }
  }, [captured, gl, scene, camera, onCapture]);

  return null;
}

const cases = [
  { id: 1, name: 'Case 1', price: 1000, textureUrl: './cases/skin.png' },
  // { id: 2, name: 'Case 2', price: 1500, textureUrl: './cases/skin.png' },
  // { id: 3, name: 'Case 3', price: 2000, textureUrl: './cases/skin.png' },
];

interface CasesPreviewProps {
  setCaseImages: (images: JSX.Element[]) => void;
}

export const CasesPreview = (props: CasesPreviewProps) => {
  const [previews, setPreviews] = useState<Record<number, string>>({});
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleCapture = (img: string) => {
    setPreviews((prev) => ({ ...prev, [cases[currentIndex].id]: img }));
    setCurrentIndex((idx) => idx + 1);
  };

  useEffect(() => {
    if (currentIndex >= cases.length && Object.keys(previews).length > 0) {
      const previewElements = cases.map(({ id, name, price }) => (
          <img
            key={id}
            src={previews[id]}
            alt={name}
            width={320}
            height={180}
            style={{ objectFit: 'contain' }}
          />
      ));
      props.setCaseImages(previewElements);
    }
  }, [currentIndex, previews, props]);

  const [ready, setReady] = useState(false);
  if (currentIndex < cases.length) {
    const currentCase = cases[currentIndex];

    return (
      <Canvas
        style={{ width: 1280, height: 720, position: 'absolute', top: 0, left: 0, opacity: 0 }}
        camera={{
          position: [
            1.35,
            1.6,
            2.5
          ],
          fov: 50
        }}
      >
        <ambientLight intensity={1} />
        <directionalLight position={[1, 1, 1]} intensity={0.8} />
        <CaseModel textureUrl={currentCase.textureUrl} playLid={false} scale={1} />
        <OrbitControls target={[0, 0.6, 0]}  enableRotate={true} enableZoom={true} enablePan={true} />
        <CaseCapture onCapture={handleCapture} />
      </Canvas>
    );
  }

  return null; // Или можно тут вернуть placeholder, пока Canvas работает
};
